export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
export function toCSVFormat(arrOfObs: any[]) {
  if (arrOfObs.length) {
    const headers = Object.keys(arrOfObs[0]);
    return [headers.join(","), ...arrOfObs.map((obj) => headers.map((key) => obj[key]).join(","))].join("\n");
  }
}
